import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
	selector: 'cv-text-box-cell-renderer',
	templateUrl: './text-box-cell.renderer.html',
	styleUrls: ['./text-box-cell.renderer.scss']
})
export class TextBoxCellRenderer implements AgRendererComponent {

	public params: ICellRendererParams;
	private rowData: any;
	public fieldValue: string;

	/**
	 * On Cell Init.
	 * @param params
	 */
	agInit(params: ICellRendererParams): void {
		this.params = params;
		this.rowData = this.params.data;
		if (params['fieldId']) {
			this.fieldValue = this.rowData[params['fieldId']];
		}
	}

	/**
	 * On Cell Refresh
	 * @param params
	 */
	refresh(params: any): boolean {
		return true;
	}

	/**
	 * On Key Up
	 * @param $event
	 */
	 onKeyUp($event: any): void {
		const newData = this.rowData;
		const value = $event.target.value.trim() === '' ? null : $event.target.value.trim();
		if (newData[this.params['fieldId']] !== undefined) {
			newData[this.params['fieldId']] = value;
		}
		if (newData[this.params['fieldName']] !== undefined) {
			newData[this.params['fieldName']] = value;
		}
		this.params.context.parentComponent.onCellUpdated(this.params, newData);
	}
}
